// External imports
import React from "react";

// Pages
import { FrontPage } from "./front-page/FrontPage";
import AboutPage from "./about/AboutPage";
import ContactPage from "./contact/ContactPage";
import NotFoundPage from "./not-found-page/NotFoundPage";
import LoginPage from "./login-page/LoginPage";

// Session guard
import { RequireAuth } from "../components/auth/RequireAuth";

// Dependency injection for the login page
import { loginUser } from "../core/ServerApiLayer/VOne/auth/login";
import { chooseRole } from "../core/ServerApiLayer/VOne/auth/choose_role";
import { setFromApiData } from "../core/LocalStorage/AuthSession/core";

/*
The routes that sit outside the admin route table.

"/" carries the login form and is where RequireAuth redirects to, so guarding it
would redirect it to itself. "/about" and "/contact" are public pages, and a 404
holds with or without a session.
 */
export const RootRoutes = [
    {
        path: "/home",
        element: (
            <RequireAuth>
                <FrontPage />
            </RequireAuth>
        ),
    },
    {
        path: "/",
        element: (
            <LoginPage
                setSessionData={setFromApiData}
                loginApiCall={loginUser}
                chooseRoleApiCall={chooseRole}
            />
        ),
    },
    {
        path: "/about",
        element: <AboutPage />,
    },
    {
        path: "/contact",
        element: <ContactPage />,
    },
    {
        path: "*",
        element: <NotFoundPage />,
    },
];
